import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Feedback } from '../components/Feedback';
import { useAuth } from '../contexts/auth-context';

/** Login do criador. Com sucesso, segue para a dashboard. */
export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro inesperado ao entrar.');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="auth-page">
      <form className="card form" onSubmit={handleSubmit}>
        <h1 className="form__title">Entrar</h1>

        <div className="form__field">
          <label className="form__label" htmlFor="email">
            E-mail
          </label>
          <input
            className="form__input"
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>

        <div className="form__field">
          <label className="form__label" htmlFor="password">
            Senha
          </label>
          <input
            className="form__input"
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        {error && <Feedback kind="error">{error}</Feedback>}

        <button className="button button--primary" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Entrando…' : 'Entrar'}
        </button>

        <p className="form__footer">
          Ainda não tem conta? <Link to="/cadastro">Cadastre-se</Link>
        </p>
      </form>
    </main>
  );
}
